module.exports = __webpack_public_path__ + "static/media/face-2.54d83349.png";